export enum ColorLabels {
  "BRAND-PRIMARY" = "colorPrimary400", //PRIMARY
  "BRAND-SECONDARY" = "colorPrimary100", // SECONDARY
  "BRAND-PRIMARY-DARK" = "colorPrimary500", //VISUALS_2
  "BRAND-SECONDARY-DARK" = "colorPrimary200", //VISUALS_3
  "NEUTRAL-PRIMARY" = "colorWhite", //BACKGROUND
  "DARK-PRIMARY" = "colorBlack", //PRIMAR_FONT
  "DARK-SECONDARY" = "colorGray800", //SECONDARY
  "DARK-TERTIARY" = "colorGray600", //VISUALS
}

export enum ButtonColorLabels {
  "BRAND-PRIMARY" = "colorPrimary400", //BACKGROUND
  "BRAND-SECONDARY" = "colorPrimary100", //FONT
  "NEUTRAL-PRIMARY" = "colorWhite", //BORDER
}
export const BASE_PRIMARY_COLOR_FIELD = "colorPrimary400";
export const BASE_BG_COLOR_FIELD = "colorWhite";
export const BASE_TEXT_COLOR_FIELD = "colorGray800";

export const PrimaryColors = [
  "colorPrimary100",
  "colorPrimary200",
  "colorPrimary300",
  "colorPrimary400",
  "colorPrimary500",
];

export const SecondaryColors = [
  "colorGray100",
  "colorGray200",
  "colorGray300",
  "colorGray400",
  "colorGray500",
  "colorGray600",
  "colorGray700",
  "colorGray800",
  "colorGray900",
];

export const TertiaryColors = [
  "colorWhite",
  "colorBlack",
  "colorEventBodyBackground",
];
